// Export API client utilities
export { apiClient, createApiClient } from './apiClient';
export { createLazyQuery } from './createLazyQuery';
export type { InternalAxiosRequestConfigMeta } from './types';
export { createQueryClient, queryClient } from './queryClient';
export { registerUnauthorizedHandler } from './errorHandler';

// Export API tags for cache invalidation
export const API_TAGS = {
  RECORDS: 'Records',
  DIALOGS: 'Dialogs',
  USERS: 'Users',
  STATISTICS: 'Statistics',
  RULES: 'Rules',
  ASSESSMENTS: 'Assessments',
  ATTRIBUTES: 'Attributes',
  ATTRIBUTE_GROUPS: 'AttributeGroups',
  CHECKLISTS: 'Checklists',
  ROLES: 'Roles',
  PROFILE: 'Profile',
  USER_GROUPS: 'UserGroups',
  PREDICATES: 'Predicates',
  DASHBOARDS: 'Dashboards',
  CONTENT: 'Content',
  TERMS: 'Terms',
  STOP_WORDS: 'StopWords',
  SETTINGS: 'Settings',
  KNOWLEDGE: 'Knowledge',
  KNOWLEDGE_SOURCES: 'KnowledgeSources',
  SAMPLES: 'Samples',
  JOBS: 'Jobs',
  SEARCH: 'Search',
  THEMES: 'Themes',
  EXPERT_REPORTS: 'ExpertReports',
  KNOWLEDGE_SETS: 'KnowledgeSets',
  AI_AGENT_CHATS: 'AiAgentChats',
  COACHING: 'Coaching',
  ANONYMIZER_CONFIG: 'AnonymizerConfig',
  EMPLOYEES: 'Employees',
  EMPLOYEE_GROUPS: 'EmployeeGroups',
  INTEGRATIONS: 'Integrations',
  USER_URL_LOGS: 'UserUrlLogs',
  BETA_FEATURES: 'BetaFeatures',
} as const;

// Export types for API tags
export type ApiTag = keyof typeof API_TAGS;
